import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import { Box } from '@rebass/grid';
import Typography from '@material-ui/core/Typography';

export const MenuItemWrapper = styled.div`
  position: relative;
  &:hover {
    .ro-dropdown-remove-icon {
      display: inline-block;
    }
  }
`;

export const TextWrapper = styled(Box)``;

export const IconWrapper = styled(Box)`
  height: 16px;
  padding: 16px 25px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  display: none;
`;

export const Text = styled(Typography)`
  width: 230px;
`;

export const RemoveIcon = styled(CloseIcon)`
  font-size: 16px !important;
  color: #ff0000;
`;
